import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

import { SidebarContextProvider } from './context/sidebar';
import { SubmissionsContextProvider } from './context/submissions';
import { TemplatesContextProvider } from './context/templates';
import { UserDetailsContextProvider } from './context/user-details';
import { CompanyDataProvider } from 'context/companyData';

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY;

const stripePromise = publishableKey ? loadStripe(publishableKey) : null;

const root = ReactDOM.createRoot(document.getElementById('root'));

const options = {
  mode: 'setup',
  currency: 'usd',
  loader: 'auto'
};

root.render(
  <BrowserRouter>
    <SidebarContextProvider>
      <UserDetailsContextProvider>
        <TemplatesContextProvider>
          <SubmissionsContextProvider>
            <CompanyDataProvider>
              <Elements stripe={stripePromise} options={options}>
                <App />
              </Elements>
            </CompanyDataProvider>
          </SubmissionsContextProvider>
        </TemplatesContextProvider>
      </UserDetailsContextProvider>
    </SidebarContextProvider>
  </BrowserRouter>
);
